export default "__VITE_ASSET__429b8412__"